import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';

interface Props {
  title: string;
  primaryColor: string;
}

const BadgeContainer = styled(Box)`
  border-radius: 2px;
  white-space: nowrap;
  padding: 2px 6px;
  font-size: 12px;
  line-height: 16px;
  color: var(--colorBlueGray200);
  border: 1px solid var(--colorBlueGray900);
`;

const ColorIndicator = styled.div<{ primaryColor: string }>`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  border: 1px solid var(--colorBlueGray200);
  background-color: ${({ primaryColor }) => primaryColor};
`;

/** UI component for displaying the membership level with its primary color */
const MembershipLevelBadge: FC<Props> = ({ title, primaryColor }) => {
  return (
    <BadgeContainer display="flex" alignItems="center" gap="xs">
      <ColorIndicator primaryColor={primaryColor} />
      {title}
    </BadgeContainer>
  );
};

export default MembershipLevelBadge;
